/**
 * Stable CSS class names for E2E — Order prio page.
 */
export const OP = {
    root: 'order-prio-page',
    headerWrap: 'order-prio-page__header-wrap',
    addNewButton: 'order-prio-page-input--button-add-new',
    gridWrap: 'order-prio-page__grid-wrap',
    loadingWrap: 'order-prio-page__loading-wrap',
    datagridWrap: 'order-prio-page__datagrid-wrap',
} as const;

